import { useState } from 'react'
import { Popover } from 'antd'
import { func, string } from 'prop-types'
import UserProfile from './UserProfiile'
import UserMenuContent from './UserMenuContent'

function UserMenu(props) {
  const { username, clientId, className, ...remainingProps } = props
  const [isMenuOpen, toggleMenu] = useState(false)
  // console.log(`username: ${username}`, `clientId: ${clientId}`)

  return (
    <div className={className}>
      <Popover
        trigger="click"
        placement="bottom"
        open={isMenuOpen}
        content={() => (
          <UserMenuContent
            username={username}
            toggleMenu={toggleMenu}
            {...remainingProps}
          />
        )}
        onOpenChange={toggleMenu}
      >
        <UserProfile toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
      </Popover>
    </div>
  )
}

UserMenu.propTypes = {
  username: string,
  clientId: string,
  onLogout: func.isRequired,
}

export default UserMenu
